import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getBookingsData = params =>
  axios.get(`${API_HOST}/bookings`, {
    params,
    withCredentials: true
  });

export const downloadBookingsData = params =>
  axios.get(`${API_HOST}/bookings/download`, {
    params,
    withCredentials: true
  });

export const acceptBookingData = (idBooking, params) =>
  axios.put(`${API_HOST}/bookings/${idBooking}`, params, {
    withCredentials: true
  });

export const bookingEnabledData = (idShop, params) =>
  axios.put(`${API_HOST}/shop/${idShop}/bookingSetting`, params, {
    withCredentials: true
  });

export default getBookingsData;
